(() => {
  class SearchableFilter extends HTMLElement {
    static label(label, param) {
      if (param !== 'filter.p.product_type') return label.trim();
      const clean = label.replace(/\s+[+&]\s+/g, ' & ').replace(/\s+/g, ' ').trim();
      const aliases = {
        'oil filter': 'Oil Filters', 'oil filters': 'Oil Filters',
        'oil cooler': 'Oil Coolers', 'oil coolers': 'Oil Coolers',
        'oil tank': 'Oil Tanks', 'oil tanks': 'Oil Tanks',
        'suspension front': 'Front Suspension', 'front suspension': 'Front Suspension',
        'oil/water pumps & parts': 'Oil & Water Pumps and Parts',
        'seals orings & kits': 'Seals, O-Rings & Kits'
      };
      return aliases[clean.toLowerCase()] || clean;
    }
    static url(base, param, values, remove) {
      const url = new URL(base);
      const existing = url.searchParams.getAll(param).filter(value => !values.includes(value));
      url.searchParams.delete(param);
      for (const value of [...new Set([...existing, ...(remove ? [] : values)])]) url.searchParams.append(param, value);
      url.searchParams.delete('page');
      return url.pathname + url.search + url.hash;
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const list = this.querySelector('ul');
      if (!list) { this.ready = false; return; }
      const param = this.dataset.param;
      const groups = new Map();
      for (const row of list.children) {
        const label = SearchableFilter.label(row.dataset.label, param);
        const key = label.toLowerCase();
        if (!groups.has(key)) groups.set(key, { label, values: [], active: false, enabled: false });
        const group = groups.get(key);
        group.values.push(row.dataset.value);
        group.active ||= row.dataset.active === 'true';
        group.enabled ||= Number(row.dataset.count) > 0;
      }
      const terms = (this.dataset.query || '').toLowerCase().split(/\s+/).filter(Boolean).map(t => t.replace(/s$/, ''));
      const score = group => param === 'filter.p.product_type' ? terms.filter(t => group.label.toLowerCase().includes(t)).length : 0;
      this.rows = [...groups.values()].sort((a, b) => Number(b.active) - Number(a.active) || score(b) - score(a) || a.label.localeCompare(b.label, undefined, { numeric: true })).map(group => {
        const li = document.createElement('li');
        li.dataset.label = group.label;
        li.dataset.active = String(group.active);
        const a = document.createElement('a');
        a.textContent = group.label;
        a.href = SearchableFilter.url(location.href, param, group.values, group.active);
        if (group.active) a.setAttribute('aria-current', 'true');
        if (!group.enabled && !group.active) { a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true'); }
        li.append(a);
        return li;
      });
      list.replaceChildren(...this.rows);
      this.input = this.querySelector('input');
      this.toggle = this.querySelector('button');
      this.querySelector('label').hidden = this.rows.length <= 8;
      this.input.addEventListener('input', () => this.refresh());
      this.toggle.addEventListener('click', () => { this.expanded = !this.expanded; this.refresh(); });
      this.refresh();
    }
    refresh() {
      const term = this.input.value.trim().toLowerCase();
      let shown = 0;
      for (const row of this.rows) {
        const matches = row.dataset.label.toLowerCase().includes(term);
        row.hidden = !matches || (!term && !this.expanded && shown >= 8 && row.dataset.active !== 'true');
        if (!row.hidden) shown++;
      }
      this.querySelector('.hp-filter-empty').hidden = shown > 0;
      this.toggle.hidden = !!term || this.rows.length <= 8;
      this.toggle.textContent = this.expanded ? this.dataset.less : this.dataset.more;
      this.toggle.setAttribute('aria-expanded', String(!!this.expanded));
    }
  }
  class ActiveFilters extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const groups = new Map();
      for (const row of this.querySelectorAll('[data-hp-active-type]')) {
        const label = SearchableFilter.label(row.dataset.hpActiveType, 'filter.p.product_type');
        const key = label.toLowerCase();
        if (!groups.has(key)) groups.set(key, { label, rows: [], values: [] });
        const group = groups.get(key);
        group.rows.push(row);
        group.values.push(row.dataset.hpActiveType);
      }
      for (const group of groups.values()) {
        const anchor = group.rows[0].querySelector('a');
        const href = SearchableFilter.url(location.href, 'filter.p.product_type', group.values, true);
        anchor.href = href;
        anchor.addEventListener('click', event => event.stopImmediatePropagation(), true);
        anchor.removeAttribute('data-filter-input');
        anchor.removeAttribute('data-url');
        anchor.querySelector('.active-filter-text').textContent = group.label;
        for (const row of group.rows.slice(1)) row.remove();
      }
    }
  }
  if (!customElements.get('hp-searchable-filter')) customElements.define('hp-searchable-filter', SearchableFilter);
  if (!customElements.get('hp-active-filters')) customElements.define('hp-active-filters', ActiveFilters);
})();
